<div fxLayout="row" style="align-items: flex-start; align-content: center">
  <button (click)="open()" mat-icon-button>
    <mat-icon class="icSearch" [icIcon]="icSearch"></mat-icon>
  </button>
  <mat-form-field [class.search-open]="isOpen" appearance="outline" class="search" fxFlex="auto">
    <mat-label>Search&hellip;</mat-label>
    <input #input (blur)="close()" matInput>
  </mat-form-field>
</div>
